/**
 * 路由配置
 */

import { createRouter, createWebHistory } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/vault',
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false, title: '登录' },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue'),
    meta: { requiresAuth: false, title: '注册' },
  },
  {
    path: '/recover',
    name: 'Recover',
    component: () => import('../views/Recover.vue'),
    meta: { requiresAuth: false, title: '重置主密码' },
  },
  {
    path: '/vault',
    name: 'Vault',
    component: () => import('../views/Vault.vue'),
    meta: { requiresAuth: true, title: '密码库' },
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('../views/Admin.vue'),
    meta: { requiresAuth: true, requiresAdmin: true, title: '管理后台' },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/vault',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 路由守卫
router.beforeEach(async (to, _from, next) => {
  const authStore = useAuthStore();

  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - ValueWarden`;
  }

  if (to.meta.requiresAuth) {
    // 需要认证的页面
    if (!authStore.isLoggedIn) {
      // 尝试从本地存储恢复
      authStore.init();

      if (!authStore.isLoggedIn) {
        next({ name: 'Login', query: { redirect: to.fullPath } });
        return;
      }
    }

    // 确保 Token 有效
    await authStore.ensureValidToken();

    // 管理后台需要管理员权限
    if (to.meta.requiresAdmin && !authStore.isAdmin) {
      next({ name: 'Vault' });
      return;
    }
  } else {
    // 不需要认证的页面，如果已登录则跳转到密码库（重置页除外，允许重置自己）
    if (authStore.isLoggedIn && (to.name === 'Login' || to.name === 'Register')) {
      next({ name: 'Vault' });
      return;
    }
  }

  next();
});

export default router;
